var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back',[_vm._v("轮播")]),_c('bar',{attrs:{"bgcolor":"blue"}},[_vm._v("这不是轮播")]),_c('check-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }